import { BASE_API_PATH } from "src/utils/constants";

export const GeographicEndpoints = {
    Continent: {
        getAll: `${BASE_API_PATH}/Continent/GetAll`,
        getAllWithFilter: `${BASE_API_PATH}/Continent/GetAllWithFilter`,
        getById: (id) => `${BASE_API_PATH}/Continent/GetById/${id}`,
        create: `${BASE_API_PATH}/Continent/Create`,
        update: (id) => `${BASE_API_PATH}/Continent/Update/${id}`,
        delete: (id) => `${BASE_API_PATH}/Continent/Delete/${id}`,
    },
    Country: {
        getAll: `${BASE_API_PATH}/Country/GetAll`,
        getAllWithFilter: `${BASE_API_PATH}/Country/GetAllWithFilter`,
        getById: (id) => `${BASE_API_PATH}/Country/GetById/${id}`,
        create: `${BASE_API_PATH}/Country/Create`,
        update: (id) => `${BASE_API_PATH}/Country/Update/${id}`,
        delete: (id) => `${BASE_API_PATH}/Country/Delete/${id}`,
    },
    District: {
        getAll: `${BASE_API_PATH}/District/GetAll`,
        getAllWithFilter: `${BASE_API_PATH}/District/GetAllWithFilter`,
        getById: (id) => `${BASE_API_PATH}/District/GetById/${id}`,
        create: `${BASE_API_PATH}/District/Create`,
        update: (id) => `${BASE_API_PATH}/District/Update/${id}`,
        delete: (id) => `${BASE_API_PATH}/District/Delete/${id}`,
    },
    Provience: {
        getAll: `${BASE_API_PATH}/Provience/GetAll`,
        getAllWithFilter: `${BASE_API_PATH}/Provience/GetAllWithFilter`,
        getById: (id) => `${BASE_API_PATH}/Provience/GetById/${id}`,
        create: `${BASE_API_PATH}/Provience/Create`,
        update: (id) => `${BASE_API_PATH}/Provience/Update/${id}`,
        delete: (id) => `${BASE_API_PATH}/Provience/Delete/${id}`,
    },
    Region: {
        getAll: `${BASE_API_PATH}/Region/GetAll`,
        getAllWithFilter: `${BASE_API_PATH}/Region/GetAllWithFilter`,
        getById: (id) => `${BASE_API_PATH}/Region/GetById/${id}`,
        create: `${BASE_API_PATH}/Region/Create`,
        update: (id) => `${BASE_API_PATH}/Region/Update/${id}`,
        delete: (id) => `${BASE_API_PATH}/Region/Delete/${id}`,
    }
};